(() => {
  let hideOwned = window.swinger.storage.get('swinger:facetted-search:hide-owned');
  let lastSelectedStreamingType = window.swinger.storage.get('swinger:facetted-search:last-selected-streaming-type');
  const url = new URL(window.location);
  const params = url.searchParams;
  const scrollingElement = document.scrollingElement || document.documentElement;
  let scrollTop = scrollingElement.scrollTop;

  const updateHideOwned = () => {
    hideOwned = window.swinger.storage.get('swinger:facetted-search:hide-owned');
    const stylesheet = document.getElementById('swinger-hide-owned') || document.createElement('style');

    stylesheet.id = 'swinger-hide-owned';

    if (!window.swinger.user.isLoggedIn() || !hideOwned) {
      stylesheet.textContent = '';
      return;
    }

    const ownedItemNumbers = window.swinger.user.getAllOwnedItemNumbers();

    stylesheet.textContent = `${ownedItemNumbers.map((itemNumber) => `.swinger-facetted-search .swinger-grid__item[data-itemnumber^="${itemNumber}"]`)} { display: none }`;
    document.head.appendChild(stylesheet);
  };

  document.addEventListener('swinger.user:authchange', () => {
    updateHideOwned();
  });

  window.swinger.observer.initialize('.swinger-facetted-search [data-fingerprint="hide-owned"] input[type="checkbox"]', (elem) => {
    const update = () => {
      if (!window.swinger.user.isLoggedIn()) {
        elem.checked = false;
        return;
      }
      elem.checked = (hideOwned === 'on');
    };

    update();

    document.addEventListener('swinger.user:authchange', () => {
      update();
    });
  }, false);

  window.swinger.observer.initialize('.swinger-facetted-search .swinger-select__select[name="order"] option[selected]', (elem) => {
    const select = elem.closest('.swinger-select__select');

    if (
      params
      && params.has
      && params.has('q')
    ) {
      const option = document.createElement('option');
      option.value = 'best_match';
      option.textContent = ' ';
      option.selected = true;

      select.appendChild(option);
      elem.selected = false;

      select.value = 'best_match';

      console.log('Appended option');
    }
  }, false);

  if (
    params
    && params.has
    && !params.has('filter[streaming_type]')
    && !params.has('filter%5Bstreaming_type%5D')
    && lastSelectedStreamingType === 'scene'
  ) {
    window.swinger.observer.initialize('.swinger-radio-group--filter\\[streaming_type\\]', () => {
      params.set('filter[streaming_type]', lastSelectedStreamingType);

      window.history.replaceState(null, document.title, url.toString());

      document.documentElement.classList.add('has-search-params');
    }, false);

    window.swinger.observer.initialize('.swinger-facetted-search input[name="filter[streaming_type]"]', (elem) => {
      lastSelectedStreamingType = window.swinger.storage.get('swinger:facetted-search:last-selected-streaming-type');

      if (!lastSelectedStreamingType) {
        return;
      }

      elem.checked = elem.getAttribute('value') === lastSelectedStreamingType;
    }, false);
  }

  window.swinger.i18n()
    .then((i18n) => {
      window.swinger.observer.initialize(
        '.swinger-facetted-search [aria-level="1"]',
        (elem) => {
          if (
            window.location.search.indexOf('?q=') === -1
          && window.location.search.indexOf('&q=') === -1
          ) {
            return;
          }

          const url = new URL(window.location);
          const params = url.searchParams;

          elem.textContent = i18n('ui.mixed-results.headline', { q: params.get('q') });
        },
        false,
      );
    })
    .catch(console.info);

  document.addEventListener('click', (e) => {
    const link = window.swinger.eventHub.getTarget(e).closest('.swinger-facetted-search [href^="#"]');
    if (!link) {
      return;
    }
    const targetId = link.getAttribute('href');
    const target = window.swinger.$(targetId, document)[0];

    target.focus({ preventScroll: true });
    e.preventDefault();
  }, true);

  const storeCurrentHeight = () => {
    const windowInnerWidth = `${window.innerWidth}`;
    const facettedSearchElem = window.swinger.$('.swinger-facetted-search')[0];

    if (!facettedSearchElem) {
      return;
    }

    document.documentElement.style.removeProperty('--swinger-facetted-search-height');

    const measuredHeight = facettedSearchElem.offsetHeight;
    const previousGeometry = window.swinger.storage.get('swinger.facetted-search.geometry') || {};
    previousGeometry[windowInnerWidth] = previousGeometry[windowInnerWidth] || {};
    previousGeometry[windowInnerWidth][window.location.href] = {
      scrollTop,
      height: facettedSearchElem.offsetHeight,
    };

    document.documentElement.style.setProperty('--swinger-facetted-search-height', `${measuredHeight}px`);
    window.swinger.storage.set('swinger.facetted-search.geometry', previousGeometry);
  };

  const setMinHeight = (e) => {
    if (
      window.performance
      && window.performance.getEntriesByType
      && window.performance.getEntriesByType('navigation')
      && window.performance.getEntriesByType('navigation').length
      && window.performance.getEntriesByType('navigation')[0].type
      && window.performance.getEntriesByType('navigation')[0].type === 'navigate'
      && (!e || e.type !== 'popstate')
    ) {
      return;
    }

    const windowInnerWidth = `${window.innerWidth}`;
    const windowLocation = window.location.href;
    const previousGeometry = window.swinger.storage.get('swinger.facetted-search.geometry');

    if (previousGeometry && previousGeometry[windowInnerWidth] && previousGeometry[windowInnerWidth][windowLocation]) {
      if (typeof previousGeometry[windowInnerWidth][windowLocation] === 'object') {
        scrollingElement.scrollTop = previousGeometry[windowInnerWidth][windowLocation].scrollTop;
        document.documentElement.style.setProperty('--swinger-facetted-search-height', `${previousGeometry[windowInnerWidth][windowLocation].height}px`);
      } else {
        document.documentElement.style.setProperty('--swinger-facetted-search-height', `${previousGeometry[windowInnerWidth][windowLocation]}px`);
      }
    }
  };

  window.addEventListener('swinger-before-pushstate', storeCurrentHeight);
  window.addEventListener('pushstate', storeCurrentHeight);
  window.addEventListener('replacestate', storeCurrentHeight);
  window.addEventListener('pagehide', storeCurrentHeight);

  window.addEventListener('popstate', setMinHeight);
  window.addEventListener('pageshow', setMinHeight);

  let scrollTopTimer;
  window.addEventListener('scroll', () => {
    window.clearTimeout(scrollTopTimer);
    scrollTopTimer = window.setTimeout(() => {
      scrollTop = scrollingElement.scrollTop;
    }, 50);
  });

  setMinHeight();
})();
